<template>
  <div class="subscribe-container">
    <div class="subscribe-header">
      <h2 class="subscribe-title">订阅我们</h2>
      <p class="subscribe-desc">请使用支付宝扫一扫下方二维码进行支付</p>
    </div>
    
    <div class="qr-codes-wrapper">
        <div class="qr-code-item">
        <div class="qr-code-box">
          <img :src="qrCode2" alt="二维码2" class="qr-code-image" />
        </div>
        <p class="qr-code-label">月付: 39.9/月</p>
      </div>
      <div class="qr-code-item">
        <div class="qr-code-box">
          <img :src="qrCode1" alt="二维码1" class="qr-code-image" />
        </div>
        <p class="qr-code-label">季付: 99.9/3个月</p>
      </div>
      
      
    </div>
  </div>
</template>

<script>
export default {
  name: 'Subscribe',
  data() {
    return {
      // 使用本地二维码图片
      qrCode1: require('../assets/img/season_pay.png'),
      qrCode2: require('../assets/img/month_pay.png')
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style scoped>
.subscribe-container {
  padding: 20px;
  max-width: 100%;
}

.subscribe-header {
  text-align: center;
  margin-bottom: 40px;
}

.subscribe-title {
  font-size: 24px;
  font-weight: bold;
  color: #656587;
  margin-bottom: 10px;
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.subscribe-desc {
  font-size: 14px;
  color: #86909c;
  margin: 0;
}

.qr-codes-wrapper {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 60px;
  flex-wrap: wrap;
  margin-top: 40px;
}

.qr-code-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 0 auto;
}

.qr-code-box {
  width: 200px;
  height: 200px;
  background: #fff;
  border-radius: 12px;
  padding: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.qr-code-box:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.15);
}

.qr-code-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;
}

.qr-code-label {
  margin-top: 20px;
  font-size: 16px;
  font-weight: 500;
  color: #656587;
  text-align: center;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .qr-codes-wrapper {
    flex-direction: column;
    gap: 40px;
  }
  
  .qr-code-box {
    width: 180px;
    height: 180px;
  }
  
  .subscribe-title {
    font-size: 20px;
  }
}
</style>

